import OfferPage from 'components/pages/Offer';

import { toCategoryLink, toSubcategoryLink } from 'lib/links';
import { resolvify } from 'lib/promises';

import { getTopbarAd } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getOfferCommentsList } from 'services/comment';
import { getCouponFeaturedStoresList } from 'services/coupon';
import { getLandingsList } from 'services/landing';
import {
  getOfferInfo,
  getOfferReviews,
  getRelatedOffers,
} from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import COMMENT from 'constants/comment';
import LINKS from 'constants/links';
import OFFER from 'constants/offer';
import STATUS_CODES from 'constants/statusCodes';

const REVIEWS_LIMIT = 3;
const REVIEWS_SORT = 'relevance';

const Offer = (props) => <OfferPage {...props} />;

export const getServerSideProps = async ({ params: { offerSlug }, query }) => {
  const { meliuzbit = null } = query;

  try {
    const [
      offer,
      offerReviews,
      serverComments,
      relatedOffers,
      categories,
      stores,
      { landings: featuredLandings },
      { landings: highlightedLandings },
      topbarAd,
      featuredStores,
    ] = await resolvify([
      getOfferInfo({
        offerId: offerSlug,
        meliuzbit,
      }),
      {
        fn: getOfferReviews({
          offerSlug,
          sort: REVIEWS_SORT,
          limit: REVIEWS_LIMIT,
        }),
        fallback: getOfferReviews.fallback,
      },
      {
        fn: getOfferCommentsList({
          limit: COMMENT.LIMIT,
          offerId: offerSlug,
          repliesLimit: COMMENT.REPLIES_LIMIT,
          sort: COMMENT.SORT_VALUES.RELEVANCE,
        }),
        fallback: [],
      },
      {
        fn: getRelatedOffers({
          limit: 4,
          offerId: offerSlug,
        }),
        fallback: { data: [] },
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      { fn: getTopbarAd(), fallback: getTopbarAd.fallback },
      {
        fn: getCouponFeaturedStoresList(),
        fallback: getCouponFeaturedStoresList.fallback,
      },
    ]);

    if (offer.offerStatusName === OFFER.STATUSES.ARCHIVED) {
      const { categorySlug, subcategorySlug } = offer;

      return {
        redirect: {
          destination: subcategorySlug
            ? toSubcategoryLink(subcategorySlug)
            : toCategoryLink(categorySlug),
          permanent: false,
        },
      };
    }

    let reviews = [];
    offer.totalReviews = 0;

    if (offerReviews.data.length > 0) {
      offer.totalReviews = offerReviews.meta.items;
      reviews = offerReviews.data;
    }

    return {
      props: {
        serverComments,
        featuredStores,
        offerKey: offerSlug,
        relatedOffers: relatedOffers.data,
        reviews,
        serverOffer: offer,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          stores,
          topbarAd,
        },
      },
    };
  } catch ({ message }) {
    // Offer can be accessed but needs authentication..
    // Fetching will be done on client
    if (message === STATUS_CODES[401]) {
      return {
        props: {
          offerKey: offerSlug,
          reviews: [],
        },
      };
    }

    // Offer can't be accessed, should redirect to origin
    if (message === STATUS_CODES[403]) {
      return { redirect: { destination: LINKS.HOME, permanent: true } };
    }

    // Offer doesn't exist
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Offer;
